import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ImageDivider = ({ image, alt, offset }) => {
  const componentClasses = classNames('divider--image', {
    [`divider--image-offset-${offset}`]: offset
  });

  return (
    <div className={componentClasses} aria-hidden="true">
      <img src={image} alt={alt} />
    </div>
  );
};

const Divider = ({ colourScheme, backgroundColour, width, image, offset, alt, customPadding }) => {
  const componentClasses = classNames('divider', {
    [`divider--${colourScheme}-scheme`]: colourScheme,
    [` divider--${width}`]: width,
    [` divider--background-${backgroundColour}`]: backgroundColour,
    [`divider--padding-${customPadding}`]: customPadding
  });

  return image ? ImageDivider({ image, offset, alt }) : <hr className={componentClasses} />;
};

Divider.propTypes = {
  backgroundColour: PropTypes.oneOf(['light-grey']),
  colourScheme: PropTypes.oneOf(['teal', 'purple', 'grey', 'light-grey', 'dark-grey', 'dark-navy', 'white']),
  width: PropTypes.oneOf(['full-width', 'half-width']),
  image: PropTypes.string,
  offset: PropTypes.oneOf(['height']),
  alt: PropTypes.string,
  customPadding: PropTypes.oneOf(['top-bottom'])
};

export default Divider;
